import React, { useState } from 'react';
import api from '../api/api';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await api.post('/auth/login', { email, password });

            const { token, user } = res.data;
            localStorage.setItem('token', token);
            localStorage.setItem('sv_token', token);
            localStorage.setItem('sv_user', JSON.stringify(user));
            if (user.OrgID) {
                localStorage.setItem('sv_active_org_id', String(user.OrgID));
                localStorage.setItem('sv_active_org_name', user.OrgName || 'Organization');
            } else {
                localStorage.setItem('sv_active_org_id', '1');
                localStorage.setItem('sv_active_org_name', 'CodexterLabs');
            }
            window.location.href = '/dashboard';

        } catch (err) {
            setLoading(false);
            alert(err.response?.data?.message || 'Login failed. Please check your credentials.');
        }
    };


    return (
        <div className="login-container">

            {/* LEFT SIDE */}
            <div className="login-left">
                <div className="login-box">

                    <div className="brand-logo">
                        <img src="/assets/logo_sv.png" alt="SalesVault Logo" className="brand-icon" width="60%" height="auto" />
                    </div>

                    <h2>Sign in</h2>

                    <form onSubmit={handleLogin}>

                        <div className="input-group">
                            <label>Email Address</label>
                            <div className="input-wrapper">
                                <span className="input-icon">
                                    <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                                </span>
                                <input
                                    type="email"
                                    placeholder="johnstone@gmail.com"
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <div className="input-group">
                            <label>Password</label>
                            <div className="input-wrapper">
                                <span className="input-icon">
                                    <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                                </span>
                                <input
                                    type="password"
                                    placeholder="••••••"
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <div className="remember-me">
                            <input type="checkbox" id="remember" />
                            <label htmlFor="remember">Remember me</label>
                        </div>

                        <button type="submit" className="login-btn">
                            Sign in
                        </button>

                    </form>

                </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="login-right">
                <div className="right-card">
                    <div className="right-card-overlay"></div>

                    <div className="login-hero-content">
                        <h1 className="login-hero-heading">
                            Get your sales lifecycle<br />
                            streamlined today
                        </h1>
                        <p className="login-hero-quote">
                            &quot;SalesVault helped us optimized our lead management, deal tracking and sales forecasting.&quot;
                        </p>

                        <div className="login-hero-avatars">
                            <img src="/assets/avatar1.jpg" alt="User 1" />
                            <img src="/assets/avatar2.jpg" alt="User 2" />
                            <img src="/assets/avatar3.jpg" alt="User 3" />
                            <img src="/assets/avatar4.jpg" alt="User 4" />
                        </div>
                    </div>

                    <div className="login-bottom-logo">
                        <img src="/assets/logo_cdlpl_wht.png" alt="CodexterLabs" />
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Login;